import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMaxHeight,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";

export const ModalBackdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 6;
  display: flex;
  justify-content: center;
  align-items: center;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
  }

  &.fadeIn {
    animation-name: fadeIn;
  }

  ${mediaMaxHeight.phone} {
    align-items: unset;
  }

  ${mediaMaxWidth.tablet} {
    align-items: unset;
  }
`;

export const Modal = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 800px;
  height: 550px;
  z-index: 5;
  padding: 10px 20px;
  position: relative;
  margin-left: 60px;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  &.fadeInUp {
    animation-name: fadeInUp;
  }

  &.delay {
    animation-delay: 0.1s;
  }

  ${mediaMaxWidth.smallDesktop} {
    margin-left: unset;
    width: calc(100vw - 30px);
  }

  ${mediaMaxWidth.tablet} {
    top: 10px;
    height: 530px;
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 20px);
    padding: 10px 10px;
  }

  ${mediaMaxHeight.phone} {
    top: 10px;
  }

  ${mediaMaxWidth.smallPhone} {
    height: 460px;
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMinWidth.smallDesktop} {
    width: 95%;
  }
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #673490;
    }
  }
`;

export const BodyWrapper = styled.div`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.animated {
    animation-duration: 1s;
    animation-fill-mode: both;
  }

  &.fadeIn {
    animation-name: fadeIn;
  }
`;

export const Body = styled.div`
  height: 420px;
  overflow: scroll;

  ${mediaMaxWidth.tablet} {
    height: 400px;
  }

  ${mediaMaxWidth.smallPhone} {
    height: 330px;
  }
`;

export const Text = styled.div`
  padding: 0 10px;

  h2 {
    margin: 20px 0 5px 0;
  }

  h2:first-of-type {
    margin: 30px 0 5px 0;
  }
`;

export const ButtonWrapper = styled.div`
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
